import React from 'react';

export const LayoutSideBar: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <div className="z-50 flex flex-col">{children}</div>;
};
